export default function HiddenField({ name, id, predefinedValue, isProfiling = false }) {
  return (
    <input
      name={name}
      id={id}
      type="hidden"
      value={predefinedValue}
      className={`Form__Element FormHidden ${isProfiling ? "FormHideInSummarized" : ""}`}
      data-f-type="hidden"
      data-f-linked-name={name}
    />
  )
}
